// Shared by the navbar (phone row) and the sidebar user menu. Signs out and keeps the
// device-level preferences listed below across localStorage.clear().
import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'
import { exitAppendMode } from '@/util/appendMode'
import { resetBikuChat } from '@/composables/useBikuChat'
import { LAST_GROUP_KEY, RECENT_KEY, resetActiveGroupSession } from '@/util/activeGroup'
import { SIDEBAR_MINIMIZED_KEY } from '@/components/SidebarPlugin'
import { clearGroupDataCache } from '@/util/groupDataCache'

export const PRESERVED_KEYS = [
  'mode',
  'showScheduleNameOnCalendar',
  'calGameSettings',
  'lastVisitedRoute',
  'kanban_filters',
  LAST_GROUP_KEY,
  RECENT_KEY,
  SIDEBAR_MINIMIZED_KEY,
]

export async function signOut(router, currentPath) {
  // Return here after the next sign in
  localStorage.setItem('lastVisitedRoute', currentPath)
  // An append session belongs to this sign in; sessionStorage survives Auth.signOut
  exitAppendMode()
  // The Biku conversation is module state and would survive SPA navigation
  resetBikuChat()
  await Auth.signOut()
  const kept = {}
  for (const k of PRESERVED_KEYS) {
    const v = localStorage.getItem(k)
    if (v) kept[k] = v
  }
  localStorage.clear()
  for (const k of Object.keys(kept)) localStorage.setItem(k, kept[k])
  // no page load follows, so drop the signed-in user's location list and state
  resetActiveGroupSession()
  // Cached users/me (permissions) and per-user settings would otherwise reach the
  // next user who signs in on this tab within the TTL (OTC-3151)
  clearGroupDataCache()
  AmplifyEventBus.$emit('authState', 'signedOut')
  router.push('/login')
}
